import React from 'react'

import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'

function SnackbarNotificationsClose(props) {
  const { onClick } = props
  return (
    <Box
      sx={{
        marginTop: 2,
        '&:hover': {
          cursor: 'pointer',
        },
        '& svg': {
          color: 'common.white',
        },
      }}
      onClick={onClick}
    >
      <CloseIcon />
    </Box>
  )
}

export default SnackbarNotificationsClose
